import React from 'react';

import { ThemeProvider } from '@change/ds-core-ui';

import { HeroSection } from './components/HeroSection';
import { HeroSection as HeroSectionExperiment } from './components/HeroSectionExperiment';
import { HowToSection } from './components/HowToSection';
import { LazyContributeSection } from './components/LazyContributeSection';
import { LazyLocalSection } from './components/LazyLocalSection';
import { LazyTrendingSection } from './components/LazyTrendingSection';
import { usePageBody } from './hooks/usePageBody';

export function PageBody(): React.JSX.Element {
	const { data } = usePageBody();
	return (
		<ThemeProvider>
			{!data.experiments.starfishHomepageToSapDraftV1.variation.includes('control') ? (
				<HeroSectionExperiment />
			) : (
				<HeroSection />
			)}

			<HowToSection />

			<div className="container space-y-16 pt-16 pb-6 md:space-y-28 md:pt-28 md:pb-[93px]">
				<LazyLocalSection />

				<LazyTrendingSection />

				<LazyContributeSection />
			</div>
		</ThemeProvider>
	);
}
